<template>
  <div>
    <div class="row">
      <v-btn
        v-for="(plan, i) in plan_ids"
        @click="togglePlans(i)"
        :key="plan.id"
        :class="['button', plan_number === i ? 'active' : null]"
      >
        <h4>{{ plan.price }} /</h4>
        <h4>{{ plan.title }}</h4>
      </v-btn>
    </div>
    <div id="paypal-plan-container"></div>
    <div ref="paypal"></div>
  </div>
</template>

<script>
export default {
  props: ['plan_ids'],
  components: {},
  data: () => ({
    plan_number: 0,
  }),
  watch: {},
  methods: {
    togglePlans(i) {
      console.log(i);
      this.plan_number = i;
    },
    setLoaded() {
      window.paypal
        .Buttons({
          locale: 'de_DE',
          style: {
            color: 'white',
            shape: 'pill',
            label: 'pay',
            height: 50,
          },
          createSubscription: (data, actions) =>
            actions.subscription.create({
              plan_id: this.plan_ids[this.plan_number].id,
            }),
          onApprove: (data, actions) => {
            if (data.orderID) {
              if (data.orderID === 'P-33R10147JF9547253LY6S3AI') {
                this.$gtm.push({ event: 'Spieler_Year' });
              }
              if (data.orderID === 'P-9UH948806H225422YLY6S2EI') {
                this.$gtm.push({ event: 'Spieler_Month' });
              }
              if (data.orderID === 'P-19H45222EM3032339LY6S33') {
                this.$gtm.push({ event: 'Trainer_Month' });
              }
              if (data.orderID === 'P-9X290641XH159201CLY6S5PQ') {
                this.$gtm.push({ event: 'Trainer_Year' });
              }
              if (
                data.orderID === 'P-8RK11651MK1491606LY6S6TY' ||
                data.orderID === 'P-33H131764U681020FLY7F4WY' ||
                data.orderID === 'P-4V6062287D6824423LZHZVHI'
              ) {
                this.$gtm.push({ event: 'Team_Year' });
              }
              if (data.orderID === 'P-0VN09541L2804242MLY6S77Q') {
                this.$gtm.push({ event: 'Team_Quarter' });
              }
              if (
                data.orderID === 'P-5EP96669G5856422CLZPDYDQ' ||
                data.orderID === 'P-8Y399747DK2950541LY7KU5I'
              ) {
                this.$gtm.push({ event: 'Scout_Year' });
              }
              if (data.orderID === 'P-6G4041299V7211200LY6TBFA') {
                this.$gtm.push({ event: 'Scout_Quarter' });
              }
            }

            this.$emit('paid', data);
          },
        })
        .render('#paypal-plan-container');
    },
  },
  beforeMount() {
    const script = document.createElement('script');
    script.src =
      'https://www.paypal.com/sdk/js?client-id=AX72_Fd_DI1ssRy3JAKW7heg5NL5qXc2AKklmcJSRcqwa3UoYPE198vD-dn5uOy287jpdW62k6pXF1cr&vault=true';
    script.addEventListener('load', this.setLoaded);

    document.body.append(script);
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
#paypal-plan-container {
  width: 400px;
  max-width: 85vw;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.active {
  color: white !important;
  @include mainLinearGradient;
}
.button {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  color: white;
  cursor: pointer;
  border-radius: 20px;
  color: green;
  height: 50px;
  margin: 10px;
  margin-top: 15px;
}
</style>
